const resellers = {
    'resellers.add': 'Invite reseller',
    'resellers.add.explanation': 'Enter a company name and contact person to send an invitation.',

    'resellers.dashboard.table.company': 'Company',
    'resellers.dashboard.table.username': 'User name',
    'resellers.dashboard.table.webshops': 'Webshops',
    'resellers.dashboard.table.feeds': 'Feeds',
    'resellers.dashboard.table.connections': 'Connections',
    'resellers.dashboard.table.subscriptions': 'Subscriptions up to',
    'resellers.dashboard.table.status': 'Status',
    'resellers.dashboard.table.empty': 'No customers were found',
    'resellers.summary': 'My reseller information',
    'resellers.summary.save': 'Save reseller',
    'resellers.summary.saving': 'Reseller is being saved...',
    'resellers.summary.reseller': 'Reseller',
    'resellers.summary.contact_information': 'Contact information',
    'resellers.summary.extra_information': 'Extra information',
    'resellers.summary.setup_completed': 'It appears that you have not yet entered all the information',
    'resellers.summary.text': 'These are the details of your resellers. Make sure this information is up to date.',
};

export default resellers;
